@if (isSpecialOfferSignal()) {
  <section class="max-w-[1600px] mx-auto h-[50vh] md:px-10 lg:px-16 py-8">
    <div class="w-full h-full md:rounded-[3rem] overflow-hidden background-img shadow-2xl">
      <div
        class="relative w-full h-full bg-linear-to-r from-primary-300/50 to-primary-900/50 flex flex-col items-center justify-center gap-10 lg:gap-5">
      <span
        class="w-full md:max-w-[70%] max-w-[60%] lg:max-w-[50%] text-center text-4xl sm:text-6xl md:text-8xl lg:text-10xl font-secondary text-secondary-100 font-semibold">Oferta specjalna jest bliżej niż myślisz</span>
        <p-button
          [navigator]="auctionsFormComponentSignal()?.id"
          [rounded]="true"
          label="PRZEJDŹ"
          styleClass="text-sm extra-padding">
        </p-button>
      </div>
    </div>
  </section>
}
